/*El estado se creo para trabajar con 3 categorias[] que son cargadas en
la accion UpDateSearch en un arreglo llamado categorias[].
A continuación se pueden ver las configuración que tiene el arreglo:
categorias[0]-> 'profesionales especialidades unidades'
categorias[1]-> 'planes'
categorias[2]-> 'localidades'
*/

import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { TagsService } from 'src/app/services/tags/tags.service';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { TagsItem } from 'src/app/interfaces/tagsItems';
import { 
  AddTagSearch, 
  Buscar, 
  LoadTagsSearch,  
  RemoveTagSearch,  
  SearchTags,
  UpDateSearchState,
  
} from './search.actions';
import { environment } from 'src/environments/environment';
import { SnackService } from 'src/app/services/utility/snacks.service';

interface SearchStateModel {
  tagsNormales: TagsItem[];
  tagsPlanes: TagsItem[];
  tagsLocalidades: TagsItem[];
  slugInstitucion: string;
  selectedTagsNormales: TagsItem[];
  selectedTagsPlanes: TagsItem[];
  selectedTagsLocalidades: TagsItem[];
  categorias: string[];
}

@State<SearchStateModel>({
  name: 'search',
  defaults: {
    tagsNormales: [],
    tagsPlanes: [],
    tagsLocalidades: [],
    selectedTagsNormales: [],
    selectedTagsPlanes: [],
    selectedTagsLocalidades: [],
    slugInstitucion: '',
    categorias: [],
  },
})
@Injectable()
export class SearchState {
  constructor(private tagsService: TagsService, private snackService:SnackService) {}

  @Selector()
  static selectedTagsNormales(state: SearchStateModel) {
    return state.selectedTagsNormales;
  }

  @Selector()
  static selectedTagsPlanes(state: SearchStateModel) {
    return state.selectedTagsPlanes;
  }

  @Selector()
  static selectedTagsLocalidades(state: SearchStateModel) {
    return state.selectedTagsLocalidades;
  }

  //Tags//
  @Selector()
  static tagsNormales(state: SearchStateModel) {
    return state.tagsNormales;
  }

  @Selector()
  static tagsPlanes(state: SearchStateModel) {
    return state.tagsPlanes;
  }

  @Selector()
  static tagsLocalidades(state: SearchStateModel) {
    return state.tagsLocalidades;
  }

  @Action(SearchTags)
  searchTags(ctx: StateContext<SearchStateModel>, action: SearchTags) {
    const state = ctx.getState();
    const slugInstitucion = state.slugInstitucion;
    const value = (
      typeof action.value === 'string'
        ? action.value
        : String(action.value || '')
    )
      .toLowerCase()
      .replace(/[\u0300-\u036f]/g, '')
      .toString();
    return this.tagsService
      .getTags(value, action.categoria, slugInstitucion, action.limite)
      .pipe(
        tap((data) => {
          const tags = data?.info?.resultados || [];
          ////////////////////////////////////////////////////////////
          //ajustar const tagsLocali=data Luego de arreglar el llamado a la APi
          ////////////////////////////////////////////////////////////
          const tagsLocali = data;
          switch (action.categoria) {
            case state.categorias[0]: // Categoría para selectedTagsNormales
              ctx.patchState({ tagsNormales: tags });
              break;
            case state.categorias[1]: // Categoría para selectedTagsPlanes
              ctx.patchState({ tagsPlanes: tags });
              break;
            case state.categorias[2]: // Categoría para selectedTagsLocalidades
              ctx.patchState({ tagsLocalidades: tags });
              break;
            default:
              console.warn(`Categoría no reconocida: ${action.categoria}`);
          }
        })
      );
  }

  @Action(LoadTagsSearch)
  loadTagsSearch(ctx: StateContext<SearchStateModel>, action: LoadTagsSearch) {
    const state = ctx.getState();
    return this.tagsService
      .getTags('', action.categoria, state.slugInstitucion, action.limite)
      .pipe(
        tap((data) => {
          const tags = data?.info?.resultados || [];
          switch (action.categoria) {
            case state.categorias[0]:
              ctx.patchState({ tagsNormales: tags });
              break;
            case state.categorias[1]:
              ctx.patchState({ tagsPlanes: tags });

              break;
            case state.categorias[2]:
              ctx.patchState({ tagsLocalidades: tags });
              break;
            default:
              console.warn(`Categoría no reconocida: ${action.categoria}`);
          }
        })
      );
  }

  @Action(AddTagSearch)
  addTagSearch(ctx: StateContext<SearchStateModel>, action: AddTagSearch) {
    const state = ctx.getState();

    switch (action.categoria) {
      case state.categorias[0]:
        const existsNormales = state.selectedTagsNormales.some(
          (tag) => tag === action.tag
        );
        if (!existsNormales) {
          const updatedTagsNormales = [
            ...state.selectedTagsNormales,
            action.tag,
          ].slice(-action.limite); 
          ctx.patchState({
            selectedTagsNormales: updatedTagsNormales,
          });
        }
        break;

      case state.categorias[1]:
        const existsPlanes = state.selectedTagsPlanes.some(
          (tag) => tag === action.tag
        );
        if (!existsPlanes) {
          const updatedTagsPlanes = [
            ...state.selectedTagsPlanes,
            action.tag,
          ].slice(-action.limite); 
          ctx.patchState({
            selectedTagsPlanes: updatedTagsPlanes,
          });
        }
        break;

      case state.categorias[2]:
        const existsLocalidades = state.selectedTagsLocalidades.some(
          (tag) => tag === action.tag
        );
        if (!existsLocalidades) {
          const updatedTagsLocalidades = [
            ...state.selectedTagsLocalidades,
            action.tag,
          ].slice(-action.limite);
          ctx.patchState({
            selectedTagsLocalidades: updatedTagsLocalidades,
          });
        }
        break;

      default:
        console.warn(`Categoría no reconocida: ${action.categoria}`);
    }
  }

  @Action(RemoveTagSearch)
  removeTagSearch(
    ctx: StateContext<SearchStateModel>,
    action: RemoveTagSearch
  ) {
    const state = ctx.getState();
    switch (action.categoria) {
      case state.categorias[0]:
        ctx.patchState({
          selectedTagsNormales: state.selectedTagsNormales.filter(
            (tag) => tag.id !== action.tag.id
          ),
        });
        break;

      case state.categorias[1]:
        ctx.patchState({
          selectedTagsPlanes: state.selectedTagsPlanes.filter(
            (tag) => tag.id !== action.tag.id
          ),
        });
        break;

      case state.categorias[2]:
        ctx.patchState({
          selectedTagsLocalidades: state.selectedTagsLocalidades.filter(
            (tag) => tag.id !== action.tag.id
          ),
        });
        break;

      default:
        console.warn(`Categoría no reconocida: ${action.categoria}`);
    }
  }

  @Action(Buscar)
  busqueda(ctx: StateContext<any>, action: Buscar) {
    const state = ctx.getState();
    
    // Concatenar las etiquetas seleccionadas y obtener los ids ordenados
    const tag = state.selectedTagsNormales
      .concat(state.selectedTagsPlanes)
      .map((data: any) => data.id)
      .sort();
  
    // Agregar el slugInstitucion y categorías de las etiquetas seleccionadas
    tag.unshift(state.slugInstitucion);
    tag.unshift(
      ...state.selectedTagsNormales.map((data: any) =>
        data.categoria.toLowerCase()
      )
    );
    if (tag.length <= 1) {//mayor a 1 porque porque se carga la institucion que siempre va a estar
      const msg =
        'Seleccione una etiqueta de búsqueda como por ejemplo Medicina Estética';
      const button = 'Aceptar';
      this.snackService.openSnackAlert(
        3500,
        {
          button,
          descripcion: msg,
          icon: 'warning',
          color: 'primary',
        },
        'end',
        'bottom'
      );
    } else {
      const params = tag.join('/');
      const url = new URL(environment.rediBusqueda + params);
      window.open(url.toString());
    }
  }
  
  @Action(UpDateSearchState)
  upDateSearchState(
    ctx: StateContext<SearchStateModel>,
    action: UpDateSearchState
  ) {
    ctx.patchState({ categorias: action.categorias });
    ctx.patchState({ slugInstitucion: action.slugInstitucion });
  
     }

}


